<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input  v-model="shop" @change="handleShop"  placeholder="输入店铺名称查询" prefix-icon="el-icon-search" clearable style="width:220px;margin-right:20px;"></el-input>
            <el-input  v-model="title" @change="handleTitle"  placeholder="输入订单号查询" prefix-icon="el-icon-search" clearable style="width:220px;margin-right:20px;"></el-input>
            <el-input  v-model="barcode" @change="handleBarcode"  placeholder="输入条形码查询" prefix-icon="el-icon-search" clearable style="width:220px;margin-right:20px;"></el-input>
            <el-select v-model="classId" @change="searchClass()" placeholder="省份筛选" style="width:220px;" clearable>
                <el-option v-for="(it, index) in province" :key="index" :value="it.id" :label="it.abbreviation"></el-option>
            </el-select>
            <div style="margin-top:20px;">
                <el-date-picker v-model="month" type="month" value-format="yyyy-MM" placeholder="月份筛选" @change="handleMonth" style="width:220px"></el-date-picker>
                <el-select v-model="payWay" @change="searchPay()" placeholder="订单类型（默认全部）" style="width:220px;margin-left:20px;" clearable>
                    <el-option v-for="(it, index) in wayList" :key="index" :value="it.id" :label="it.name"></el-option>
                </el-select>
                <el-select v-model="payId" @change="searchPay()" placeholder="支付方式（默认全部）" style="width:220px;margin-left:20px;" clearable>
                    <el-option v-for="(it, index) in payList" :key="index" :value="it.id" :label="it.name"></el-option>
                </el-select>
                <el-button type="success" plain  style="width:120px;margin-left:20px;" @click="onSend()">导出报表</el-button>
            </div>
        </div>
        <!-- 商品列表 -->
        <el-card >
            <el-table ref="table" :data="tableData" :cell-style="handleCell" height="540" >
                <el-table-column label="日期"  min-width="170" align="center">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.sales_date }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_number" label="订单号"  align="center" min-width="170"></el-table-column>
                <el-table-column prop="store_name" label="店铺名称" align="center" width="80"> </el-table-column>
                <el-table-column prop="order_amount" label="订单总价" align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.order_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="goods_amount" label="商品总价"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.goods_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="goods_discount_fee" label="折扣金额"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.goods_discount_fee}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="goods_wallet_fee" label="钱包抵扣"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.goods_wallet_fee}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="way" label="订单类型"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.way == 1 ? '线下': '线上'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payment_method" label="支付方式"  align="center" ></el-table-column>
                <el-table-column prop="shipping_fee" label="运费"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.shipping_fee}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="gst_amount" label="GST"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.gst_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pst_amount" label="PST"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.pst_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="qst_amount" label="QST"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.qst_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="hst_amount" label="HST"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.hst_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_price" label="订单实付金额"  align="center" width="120">
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.order_price}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="refund_amount" label="退款金额"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.refund_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sales_province" label="销售省份"  align="center" > </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" :page-size="size" ></el-pagination>
        </el-card>
    </section>
</template>



<script>
import { monthly_bookkeeping } from '@/api/platform.js'
export default {
    data() {
        return {
            shop: '',
            title: '',
            barcode: '',
            month: '',
            classId:'',
            payId: '',
            payWay: '',
            payList: [
                {id: 0, name: '全部'},
                {id: 1, name: '支付宝、微信'},
                {id: 2, name: '信用卡'},
                {id: 3, name: 'PayPal'},
                {id: 5, name: '现金'},
                {id: 6, name: 'EMT'},
                // {id: 4, name: '线下'}
            ],
            wayList: [
                {id: '3', name: '全部'},
                {id: '0', name: '线上'},
                {id: '1', name: '线下'},
            ],
            province: [],
            tableData:[],
            status:0,
            total:0,
            page:1,
            size: 10,
        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page
            }
            if(this.shop != ""){
                params.shops_title = this.shop;
            }
            if(this.title != ""){
                params.order_title = this.title;
            }
            if(this.barcode != ""){
                params.barcode = this.barcode;
            }
            if(this.month != ""){
                params.month = this.month
            }
            if (this.classId != "") {
                params.province_id = this.classId
            }
            if (this.payId !== "") {
                params.pay_method = this.payId
            }
            if (this.payWay !== "") {
                if(this.payWay == '3') {
                    params.way = ''
                } else {
                    params.way = this.payWay
                }
            }
            monthly_bookkeeping(params).then(res => {
                if(res){
                    this.tableData = res.data.list.data
                    this.province = res.data.province
                    this.total = res.data.list.total
                }else{
                    this.tableData = [];

                }
            })
        },
       // 确认导出
        onSend(){
            // if (!this.month ) {
            //     this.$message({ type:'error', message:'请先选择月份！' })
            //     return false
            // }
            // if(this.payId === '') {
            //     this.$message({ type:'error', message:'请先选择支付方式！' })
            //     return false
            // }
            var a = document.createElement("a");
            a.href = `https://admintapi.moobyyoho.com/finance/monthly-bookkeeping-export?pay_method=${this.payId}&month=${this.month}&way=${this.payWay== '3' ? '' : this.payWay}`;
            a.click();
            
        },
        // 订单号搜索
        handleShop(){
            this.title = ''
            this.barcode = ''
            this.classId = ''
            this.month = ''
            this.page = 1
            this.getData()
        },
        // 订单号搜索
        handleTitle(){
            this.shop = ''
            this.barcode = ''
            this.classId = ''
            this.month = ''
            this.page = 1
            this.getData()
        },
         // 条形码搜索
        handleBarcode(){
            this.title = ''
            this.month = ''
            this.classId = ''
            this.payId = ''
            this.page = 1
            this.getData()
        },
        // 月份搜索
        handleMonth(){
            this.title = ''
            this.classId = ''
            this.page  = 1
            this.getData()
        },
        searchClass() {
            this.title = ''
            this.shop = ''
            this.barcode = ''
            this.month = ''
            this.payId = ''
            this.page = 1
            this.getData()
        },
        searchPay() {
            this.title = ''
            this.shop = ''
            this.barcode = ''
            this.classId = ''
            this.page = 1
            if(this.payWay === '2') {
                this.payList = [
                    {id: 0, name: '全部'},
                    {id: 1, name: '支付宝、微信'},
                    {id: 2, name: '信用卡'},
                    {id: 3, name: 'PayPal'}
                ]
            } else {
                this.payList = [
                    {id: 0, name: '全部'},
                    {id: 1, name: '支付宝、微信'},
                    {id: 2, name: '信用卡'},
                    {id: 3, name: 'PayPal'},
                    {id: 5, name: '现金'},
                    {id: 6, name: 'EMT'},
                ]
            }
            this.getData()
        },
        // 点击页数 加载当前点击页的数据
        reloadData(page){
            this.page = page
            this.getData()
        },

        // 设置cell 格式
        handleCell(obj ) {
            if([4].includes(obj.columnIndex)){
                return 'color:red'
            }
            // if([9].includes(obj.columnIndex)){
            //     return 'color: #67c23a'
            // }
           
        },

      
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tag + .el-tag{ 
        margin-left: 20px;
    }
    
}
</style>
